
export function set (state, n) {
  state.session = n
  if (sessionStorage) {
    sessionStorage.setItem("session", JSON.stringify(n))
  }
}

export function clear (state) {
  state.session = null
  sessionStorage.clear()
}
